import { render, staticRenderFns } from "./printInfo.vue?vue&type=template&id=1855f006&scoped=true&"
import script from "./printInfo.vue?vue&type=script&lang=js&"
export * from "./printInfo.vue?vue&type=script&lang=js&"
import style0 from "./printInfo.vue?vue&type=style&index=0&id=1855f006&lang=scss&scoped=true&"
import style1 from "./printInfo.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1855f006",
  null
  
)

export default component.exports